(() => {
  "use strict";

  // function here

  function hideNewsLetterImage() {
    function main() {
      const style = document.createElement("style");
      style.textContent = `
            @media screen and (max-width: 768px) {
                #app-embed div[data-testid="image"] { 
                    display:none;
                }

                #app-embed ._grid_stahb_148._left_stahb_195 {
                    display:block;
                }

                ._grid_1q1d2_148._left_1q1d2_195 {
                  grid-template: 1fr / 1fr !important;
                }

                #app-embed {
                  z-index: 900000!important;
                }

                ._grid_1q1d2_148._left_1q1d2_195 ._gridItem_1q1d2_172:nth-child(1){
                    background-image: none!important;
                    background-color: white !important;
                }
            }
        `; 

      const newsLetterEmb = document.querySelector(
        "#app-embed-container-132072"
      );

      if (newsLetterEmb && newsLetterEmb.shadowRoot) {
        newsLetterEmb.shadowRoot.append(style);
        return true; // Indicate successful execution
      }
      return false; // Indicate failure to execute
    }

    if (!main()) {
      // Try running main immediately
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            const appEmbedContainer = document.querySelector(
              "#app-embed-container-132072"
            );

            if (appEmbedContainer) {
              observer.disconnect(); // Stop observing further changes
              main();
              break;
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    // function call here
    hideNewsLetterImage();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
